import {PayloadAction} from '@reduxjs/toolkit';

type pageData = {
    page:string;
    data:any
};

export const setPageData = (state, action:PayloadAction<pageData>) => {
    const page = action.payload.page;

    state[page] = action.payload.data;
    state.currentPage = page;
};